import angular from 'angular';
import './monitoring.service.js';

class MonitoringCtrl {
    /*@ngInject*/
    constructor($q, logger, CONF, MonitoringSvc) {
        this.$q = $q;
        this.logger = logger;
        this.CONF = CONF;
        this.MonitoringSvc = MonitoringSvc;
    }

    $onInit() {
        var vm = this;

        vm.baseUrl = null;
        var indicatorsList = null;

        vm.loading = true;
        vm.showdetails = false;
        vm.indicators = [];
        vm.app = this.application;

        vm.refresh = refresh;
        vm.getStatusIcon = getStatusIcon;
        vm.getStatusColor = getStatusColor;

        vm.baseUrl = this.CONF.apiContext;
        switch (vm.app) {
            case 'kiss':
                vm.baseUrl += this.CONF.apiBaseUrl + '/v1';
                break;
            case 'epdf':
                vm.baseUrl += this.CONF.proxyEpdf + this.CONF.apiBaseUrl + '/v1';
                break;
            case 'zedoc':
                vm.baseUrl += this.CONF.proxyZeDoc + this.CONF.apiBaseUrl + '/v1';
                break;
            case 'prepasrel':
                vm.baseUrl += this.CONF.proxyPrePasrel + this.CONF.apiBaseUrl + '/v1';
                break;
            default:
                //error
                this.logger.error('l\'application "' + vm.app + '" est inconnue');
                return;
        }

        vm.baseUrl += '/health';

        //recuperer la liste des indicateurs
        this.MonitoringSvc.getIndicatorsList(vm.baseUrl).then(
            function (list) {
                indicatorsList = list;
                load(indicatorsList);
            },
            function (/*error*/) {
                this.logger.error('error.generic');
                vm.loading = false;
            }
        );

        function refresh() {
            vm.loading = true;
            vm.indicators = [];
            if (indicatorsList !== null) {
                load(indicatorsList);
            } else {
                vm.loading = false;
            }
        }

        function load(indicatorsList) {
            var promises = [];
            for (var i in indicatorsList) {
                var promise = vm.MonitoringSvc.getIndicatorHealth(vm.baseUrl, indicatorsList[i]);
                promises.push(promise);
                handleModuleResult(promise);
            }
            vm.$q.all(promises).then(function () {
                vm.loading = false;
            });
        }

        function handleModuleResult(promise) {
            promise.then(function (result) {
                vm.indicators.push(result);
            });
        }

        function getStatusIcon(status) {
            var lowerStatus = angular.lowercase(status);
            if (lowerStatus === 'up') {
                return 'fa-arrow-circle-up';
            } else {
                return 'fa-arrow-circle-down';
            }
        }

        //UNKNOWN, UP, DOWN, STOPPED, MALFUNCTIONING
        function getStatusColor(status) {
            var lowerStatus = angular.lowercase(status);
            if (lowerStatus === 'up') {
                return 'green';
            } else if (lowerStatus === 'down') {
                return 'red';
            } else if (lowerStatus === 'malfunctioning') {
                return 'orange';
            } else if (lowerStatus === 'unknown') {
                return 'grey';
            } else {
                return 'grey';
            }
        }
    }
}

angular.module('app.admin.monitoring').component('monitoring', {
    templateUrl: require('./monitoring.html'),
    controller: MonitoringCtrl,
    bindings: {
        application: '<',
    },
});
